/**
 * Story / Journal: 本文画像の表示サイズを整数 px にスナップ
 * width:100% 縮小時の小数 px 高さによるボケ対策
 *
 * 対象: .story-img
 * Shopify: story-journal-assets スニペット経由で defer 読み込み
 */
(function () {
  'use strict';

  var SNAP_ATTR = 'data-story-img-snapped';
  var SELECTOR = '.story-img';
  var RESIZE_DELAY = 120;

  function getTargetWidth(img) {
    var parent = img.parentElement;
    if (!parent) return 0;
    return Math.floor(parent.clientWidth);
  }

  function snapImage(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;

    var w = getTargetWidth(img);
    if (w <= 0) return;

    var h = Math.round((w * img.naturalHeight) / img.naturalWidth);
    if (h <= 0) return;

    var key = w + 'x' + h;
    if (img.getAttribute(SNAP_ATTR) === key) return;

    img.style.width = w + 'px';
    img.style.height = h + 'px';
    img.style.maxWidth = '100%';
    img.setAttribute(SNAP_ATTR, key);
  }

  function bindImage(img) {
    if (img.complete && img.naturalWidth) {
      snapImage(img);
      return;
    }
    img.addEventListener(
      'load',
      function () {
        snapImage(img);
      },
      { once: true }
    );
  }

  function snapAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(function (img) {
      img.removeAttribute(SNAP_ATTR);
      bindImage(img);
      if (img.complete && img.naturalWidth) snapImage(img);
    });
  }

  function init() {
    snapAll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        snapAll();
      }, RESIZE_DELAY);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var target = entry.target;
          if (target.matches && target.matches(SELECTOR)) {
            target.removeAttribute(SNAP_ATTR);
            snapImage(target);
          }
          if (target.querySelectorAll) {
            target.querySelectorAll(SELECTOR).forEach(function (img) {
              img.removeAttribute(SNAP_ATTR);
              snapImage(img);
            });
          }
        });
      });

      document
        .querySelectorAll('.story-figure-block, .story-rail, .article-template__content--rte-wide')
        .forEach(function (el) {
          ro.observe(el);
        });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
